import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetSalesReportSalesLedger = async (params: {
  start_date: string;
  end_date: string;
  types?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/reports/sales-ledger`, {
      params,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load sales ledger report.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetSalesReportItemProfit = async (params: {
  start_date: string;
  end_date: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/reports/item-profit`, {
      params,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load item profit report.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetSalesReportCashFlow = async (params: {
  start_date: string;
  end_date: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/reports/cash-flow`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load cash flow report.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetSalesReportCheques = async (params: {
  start_date: string;
  end_date: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/reports/cheques`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load cheque report.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetSalesReportDiscounts = async (params: {
  start_date: string;
  end_date: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/reports/discounts`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load discounts report.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetSalesReportNonCashPayments = async (params: {
  start_date: string;
  end_date: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/reports/non-cash-payments`, {
      params,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load payments report.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetSalesReportEmployeePerformance = async (params: {
  start_date: string;
  end_date: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/reports/employee-performance`, {
      params,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load employee report.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetInventoryReportProductStock = async (params: {
  search?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/reports/product-stock`, {
      params,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load stock report.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetInventoryReportExpiringItems = async (params: {
  days_limit: number;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/reports/expiring-items`, {
      params,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        "Failed to load expiring items report.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetInventoryReportPurchases = async (params: {
  start_date: string;
  end_date: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/reports/purchases`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load purchases report.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetInventoryReportPurchasedProducts = async (params: {
  start_date: string;
  end_date: string;
  search?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/reports/purchased-products`, {
      params,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        "Failed to load purchased products report.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetInventoryReportReturnedItems = async (params: {
  start_date: string;
  end_date: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/reports/returned-items`, {
      params,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        "Failed to load returned items report.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetInventoryReportSoldItems = async (params: {
  start_date: string;
  end_date: string;
  search?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/reports/sold-items`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load sold items report.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetSalesReportCashOuts = async (params: {
  page?: number;
  limit?: number;
  search?: string;
  store_id?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/cash-out`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load closed shifts.",
      data: { cash_outs: [], total: 0 },
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetSignOffReport = async (params: {
  id: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/reports/sign-off`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load sign off report.",
      data: null,
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};
